import { ErrorBoundary } from '@sentry/react'
import React, { Suspense } from 'react'
import { LuX } from 'react-icons/lu'
import { useSearchParams } from 'react-router'

import CompanyProfileSkeleton from '@/components/misc/CompanyProfile/components/CompanyProfileSkeleton'
import FirmDetailsNotFound from '@/components/misc/FirmDetailsNotFound'
import FullPageErrorFallback from '@/components/misc/FullPageErrorFallback'
import PanelInvite from '@/components/modals/PanelInviteModal/components/PanelInvite'
import {
  PANEL_INVITE_MODAL_SEARCH_PARAMS,
  usePanelInviteModal,
} from '@/components/modals/PanelInviteModal/hooks/usePanelInviteModal'
import {
  Drawer,
  DrawerBody,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
} from '@/components/ui/drawer'
import errorTypeService from '@/lib/services/errorTypeService'

const PanelInviteModal: React.FC = () => {
  const modal = usePanelInviteModal()
  const [searchParams] = useSearchParams()
  const source = searchParams.get(PANEL_INVITE_MODAL_SEARCH_PARAMS.source)
  const sourceId = searchParams.get(PANEL_INVITE_MODAL_SEARCH_PARAMS.sourceId)

  if (!modal.isShowing || !source || !sourceId) {
    return null
  }

  return (
    <Drawer open direction="right" onHide={modal.hide}>
      <DrawerContent>
        <DrawerHeader className="flex flex-row justify-between gap-2 px-4">
          <div />

          <DrawerClose asChild>
            <LuX className="text-xl" />
          </DrawerClose>
        </DrawerHeader>

        <DrawerBody>
          <ErrorBoundary
            fallback={(error) =>
              errorTypeService.is404Error(error.error) ? (
                <FirmDetailsNotFound className="px-6" />
              ) : (
                <FullPageErrorFallback
                  error={error}
                  className="mt-0"
                  cardProps={{ className: 'box-shadow-lg p-2' }}
                />
              )
            }
          >
            <Suspense fallback={<CompanyProfileSkeleton />}>
              <PanelInvite source={source} sourceId={+sourceId} />
            </Suspense>
          </ErrorBoundary>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  )
}

export default PanelInviteModal
